// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1_2cZ","title":"Info_title__QRg9V","links":"Info_links__3OksL","link":"Info_link__164i-","logo":"Info_logo__3Whvz"};